export interface CourseVideo {
  id: string;
  url: string;
  title: string;
}

export interface Course {
  id: string;
  name: string;
  description: string;
  playlistUrl: string;
  videos: CourseVideo[];
  thumbnailColor: string;
}

// Helper to extract YouTube video id from a watch URL
const v = (id: string, title: string, index: number, list: string): CourseVideo => ({
  id,
  title,
  url: `https://www.youtube.com/watch?v=${id}&list=${list}&index=${index}`,
});

export const coursesData: Course[] = [
  {
    id: "antigravity-course",
    name: "AntiGravity Course",
    description:
      "Master AntiGravity from the ground up full course covering setup, workflows and advanced automation.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN",
    thumbnailColor: "from-blue-600 to-purple-600",
    videos: [
      v("QZCYFJTv8jI", "AntiGravity — Lesson 1", 1, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("QgisBAqkJ4M", "AntiGravity — Lesson 2", 2, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("tkxKnPklJhY", "AntiGravity — Lesson 3", 3, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("quVoGwHZdYI", "AntiGravity — Lesson 4", 4, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("cgl5tFN2zxA", "AntiGravity — Lesson 5", 5, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("UR09nuSxGio", "AntiGravity — Lesson 6", 6, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("cCIiRnlyipE", "AntiGravity — Lesson 7", 7, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("X__6Zjltw48", "AntiGravity — Lesson 8", 8, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("Yn2v1Hdrf4Y", "AntiGravity — Lesson 9", 9, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("8yh6XeUUU38", "AntiGravity — Lesson 10", 10, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("qJsDfREUwDs", "AntiGravity — Lesson 11", 11, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
      v("mvHGl6zEA3w", "AntiGravity — Lesson 12", 12, "PLuT8wfgyV8tjGHAYNHJ9wPES3BEq-TnKN"),
    ],
  },
  {
    id: "claude-code-tutorial",
    name: "Claude Code Tutorial",
    description:
      "Step-by-step Claude Code tutorial build, ship and automate with Anthropic's coding agent.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY",
    thumbnailColor: "from-yellow-600 to-orange-600",
    videos: [
      v("SUysp3sJHbA", "Claude Code — Lesson 1", 1, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("i_OHQH4-M2Y", "Claude Code — Lesson 2", 2, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("ob-mYGqqFQw", "Claude Code — Lesson 3", 3, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("Lr37J1ZUeZI", "Claude Code — Lesson 4", 4, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("TU0ZcDFq0e0", "Claude Code — Lesson 5", 5, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("MTGJuu9CeMk", "Claude Code — Lesson 6", 6, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("52KBhQqqHuc", "Claude Code — Lesson 7", 7, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("X7lgIa6guKg", "Claude Code — Lesson 8", 8, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("Phr7vBx9yFQ", "Claude Code — Lesson 9", 9, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("7pKN_pjPW04", "Claude Code — Lesson 10", 10, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
      v("cCHPjvswTpQ", "Claude Code — Lesson 11", 11, "PL4cUxeGkcC9g4YJeBqChhFJwKQ9TRiivY"),
    ],
  },
  {
    id: "claude-cowork-ultimate",
    name: "Claude Cowork Ultimate Course (Beginner to Expert)",
    description:
      "The ultimate Claude Cowork course go from complete beginner to expert collaborator.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi",
    thumbnailColor: "from-pink-600 to-red-600",
    videos: [
      v("YHx-E8NOg8s", "Claude Cowork — Lesson 1", 1, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("uVfj5fEihOk", "Claude Cowork — Lesson 2", 2, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("NDHWUhGzKg0", "Claude Cowork — Lesson 3", 3, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("grh7CMl960s", "Claude Cowork — Lesson 4", 4, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("wXQGd-Yg8Ac", "Claude Cowork — Lesson 5", 5, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("5bhh8ffHN6Q", "Claude Cowork — Lesson 6", 6, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("mnsDx7HDwls", "Claude Cowork — Lesson 7", 7, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("LxJz0ITHAqI", "Claude Cowork — Lesson 8", 8, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("RL6hK-Xo7cM", "Claude Cowork — Lesson 9", 9, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("f95-O8C88uw", "Claude Cowork — Lesson 10", 10, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("b9gvuODIiQU", "Claude Cowork — Lesson 11", 11, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("MMHa28g0z6k", "Claude Cowork — Lesson 12", 12, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
      v("nA-_ANMtAU8", "Claude Cowork — Lesson 13", 13, "PL8j3ghxItKTkFXkFvPg1xMqoOZf-jkYhi"),
    ],
  },
  {
    id: "claude-cowork-tutorials-full",
    name: "Claude Cowork Tutorials (Full Course)",
    description:
      "Complete Claude Cowork tutorial series with hands-on workflows and real-world projects.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D",
    thumbnailColor: "from-green-600 to-teal-600",
    videos: [
      v("oagNcuK5s6I", "Claude Cowork Full — Lesson 1", 1, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("MCMkmshUN8U", "Claude Cowork Full — Lesson 2", 2, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("VZGFhfzFyhI", "Claude Cowork Full — Lesson 3", 3, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("rqte_LEu2Y8", "Claude Cowork Full — Lesson 4", 4, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("8LNZqLaXEGM", "Claude Cowork Full — Lesson 5", 5, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("t7vlZ866TUg", "Claude Cowork Full — Lesson 6", 6, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("nBXXBaqMURA", "Claude Cowork Full — Lesson 7", 7, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("Hi2hCaz2Kok", "Claude Cowork Full — Lesson 8", 8, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("Up-8lNZMDzE", "Claude Cowork Full — Lesson 9", 9, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("rxInH0bQdG8", "Claude Cowork Full — Lesson 10", 10, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("EuqqdVLMBms", "Claude Cowork Full — Lesson 11", 11, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("cm6sl-7-wks", "Claude Cowork Full — Lesson 12", 12, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("o-5Esj459GQ", "Claude Cowork Full — Lesson 13", 13, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("wEpw20UIfzI", "Claude Cowork Full — Lesson 14", 14, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("bdZ7KHx0WpU", "Claude Cowork Full — Lesson 15", 15, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("U7n6i2_P7QM", "Claude Cowork Full — Lesson 16", 16, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("zeqMDu9QN1U", "Claude Cowork Full — Lesson 17", 17, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("cA6mE6JgfK0", "Claude Cowork Full — Lesson 18", 18, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("_gYthLMXlsA", "Claude Cowork Full — Lesson 19", 19, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
      v("L_-l9yjHxFs", "Claude Cowork Full — Lesson 20", 20, "PLcQVY5V2UY4Jrx9dhHVM9M_EUcp_JJi0D"),
    ],
  },
  {
    id: "openclaw-course",
    name: "OpenClaw",
    description:
      "Hands-on OpenClaw course learn to build scalable AI integrations from the ground up.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PLIWHjbvRtljgWx4JbSun70CQgKaxO-X7j",
    thumbnailColor: "from-indigo-600 to-blue-600",
    videos: [
      v("AcwK1Uuwc0U", "OpenClaw — Lesson 1", 1, "PLIWHjbvRtljgWx4JbSun70CQgKaxO-X7j"),
      v("nSBKCZQkmYw", "OpenClaw — Lesson 2", 2, "PLIWHjbvRtljgWx4JbSun70CQgKaxO-X7j"),
      v("ji_Sd4si7jo", "OpenClaw — Lesson 3", 3, "PLIWHjbvRtljgWx4JbSun70CQgKaxO-X7j"),
      v("4zXQyswXj7U", "OpenClaw — Lesson 4", 4, "PLIWHjbvRtljgWx4JbSun70CQgKaxO-X7j"),
    ],
  },
  {
    id: "cowork-masterclass",
    name: "Cowork Masterclass",
    description:
      "The Cowork masterclass advanced patterns, automations and real-world workflows.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS",
    thumbnailColor: "from-red-600 to-pink-600",
    videos: [
      v("cNf7uVff11Y", "Cowork Masterclass — Lesson 1", 1, "PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS"),
      v("QoQBzR1NIqI", "Cowork Masterclass — Lesson 2", 2, "PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS"),
      v("cJ2QCyr3yzU", "Cowork Masterclass — Lesson 3", 3, "PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS"),
      v("vv09DHej6gg", "Cowork Masterclass — Lesson 4", 4, "PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS"),
      v("cm6sl-7-wks", "Cowork Masterclass — Lesson 5", 5, "PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS"),
      v("CpDM2ZXapBs", "Cowork Masterclass — Lesson 6", 6, "PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS"),
      v("X3uum6W2xEI", "Cowork Masterclass — Lesson 7", 7, "PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS"),
      v("rpOCyg1ZkDc", "Cowork Masterclass — Lesson 8", 8, "PLXJ1BGegtcGh7BNj1KsXSZ4sqi9PTOoBS"),
    ],
  },
  {
    id: "antigravity-google",
    name: "AntiGravity Google",
    description:
      "AntiGravity x Google deep-dive full automation course for the Google ecosystem.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi",
    thumbnailColor: "from-purple-600 to-pink-600",
    videos: [
      v("ns5yYA_nh3Y", "AntiGravity Google — Lesson 1", 1, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("dgwtzpJ3rE4", "AntiGravity Google — Lesson 2", 2, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("VEiumna7MTM", "AntiGravity Google — Lesson 3", 3, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("OqvYyWyLnPs", "AntiGravity Google — Lesson 4", 4, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("mvHGl6zEA3w", "AntiGravity Google — Lesson 5", 5, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("KmXfxcGhJDE", "AntiGravity Google — Lesson 6", 6, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("EZdSVpgtjG0", "AntiGravity Google — Lesson 7", 7, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("T5LHXiTncp0", "AntiGravity Google — Lesson 8", 8, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("UwyUHOq1hIA", "AntiGravity Google — Lesson 9", 9, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("PLD8KHFpo6U", "AntiGravity Google — Lesson 10", 10, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("C4fTWiOGXpM", "AntiGravity Google — Lesson 11", 11, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("gh9Y3tHeFXQ", "AntiGravity Google — Lesson 12", 12, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("gcuR_-rzlDw", "AntiGravity Google — Lesson 13", 13, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("qpyhrrCAOro", "AntiGravity Google — Lesson 14", 14, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("rp6_d6sNYXY", "AntiGravity Google — Lesson 15", 15, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("aw_k00T4UFk", "AntiGravity Google — Lesson 16", 16, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("cgl5tFN2zxA", "AntiGravity Google — Lesson 17", 17, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
      v("cFThM_D3nl8", "AntiGravity Google — Lesson 18", 18, "PLNoYxk1xuek4cdobz_ZYGv12w2V_lM6Pi"),
    ],
  },
  {
    id: "clawbot-money-making",
    name: "Clawbot Money Making",
    description:
      "Practical Clawbot money-making course turn AI workflows into real income streams.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU",
    thumbnailColor: "from-emerald-600 to-green-600",
    videos: [
      v("XC5oeZnMvcg", "Clawbot Money Making — Lesson 1", 1, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("o0ZDDkNd1Ns", "Clawbot Money Making — Lesson 2", 2, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("j9eRyAnr4c0", "Clawbot Money Making — Lesson 3", 3, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("LOwscgNHaXc", "Clawbot Money Making — Lesson 4", 4, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("PrWZe0VmnGg", "Clawbot Money Making — Lesson 5", 5, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("U8kXfk8enrY", "Clawbot Money Making — Lesson 6", 6, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("CnMlXwyA288", "Clawbot Money Making — Lesson 7", 7, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("a63dUwXUgDo", "Clawbot Money Making — Lesson 8", 8, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("fH40X1CK9NM", "Clawbot Money Making — Lesson 9", 9, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
      v("qTzzX_0Rwlg", "Clawbot Money Making — Lesson 10", 10, "PLFB7T8cgX0VrFl6_O25dlAJR0q0eiGCSU"),
    ],
  },
  {
    id: "n8n-tutorials",
    name: "n8n Tutorials",
    description:
      "Complete n8n tutorial series learn n8n from beginner to advanced with 30+ hands-on lessons.",
    playlistUrl:
      "https://www.youtube.com/playlist?list=PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe",
    thumbnailColor: "from-orange-600 to-red-600",
    videos: [
      v("4cQWJViybAQ", "n8n Tutorials — Lesson 1", 1, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("77Z07QnLlB8", "n8n Tutorials — Lesson 2", 2, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("lkudvrC3AOU", "n8n Tutorials — Lesson 3", 3, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("yzvLfHb0nqE", "n8n Tutorials — Lesson 4", 4, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("9E3XU0WKoXY", "n8n Tutorials — Lesson 5", 5, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("xz_X2N-hPg0", "n8n Tutorials — Lesson 6", 6, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("IJdt_Ds-gmc", "n8n Tutorials — Lesson 7", 7, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("Ridgm0WXV0s", "n8n Tutorials — Lesson 8", 8, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("m6EH-jWIJQI", "n8n Tutorials — Lesson 9", 9, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("ODdRXozldPw", "n8n Tutorials — Lesson 10", 10, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("cve5U-RCpHs", "n8n Tutorials — Lesson 11", 11, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("-3dSAsr91N8", "n8n Tutorials — Lesson 12", 12, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("gn_UG_RBiEw", "n8n Tutorials — Lesson 13", 13, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("W2OFdhJOCD8", "n8n Tutorials — Lesson 14", 14, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("mUbGmQwZWtU", "n8n Tutorials — Lesson 15", 15, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("pK4EeXuR8pc", "n8n Tutorials — Lesson 16", 16, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("RpjQTGKm-ok", "n8n Tutorials — Lesson 17", 17, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("c1sIl4_wCVQ", "n8n Tutorials — Lesson 18", 18, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("pfYr_cJXDLA", "n8n Tutorials — Lesson 19", 19, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("NEuto0F41WY", "n8n Tutorials — Lesson 20", 20, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("rn3-d4IiW44", "n8n Tutorials — Lesson 21", 21, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("3w7xIMKLVAg", "n8n Tutorials — Lesson 22", 22, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("wGAEAcfwV8w", "n8n Tutorials — Lesson 23", 23, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("ovlxledZfM4", "n8n Tutorials — Lesson 24", 24, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
      v("JIaxjH2CyFc", "n8n Tutorials — Lesson 25", 25, "PLlET0GsrLUL5HKJk1rb7t32sAs_iAlpZe"),
    ],
  },
];
